/** PostHog US Cloud ingest host — same across all environments today. */
export const POSTHOG_HOST = 'https://us.i.posthog.com';
